// extracted by mini-css-extract-plugin
export default {"languagePicker":"LanguagePicker_languagePicker__3s+l9"};